import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import TopUpStatusMessage from './TopUpStatusMessage';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const NotTopUpEligible = () => {
    const stateKey = useStateKey();

    const {
        data: customerStateRepsponse,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey })
    });

    if (isLoading || isError) return null;

    const companyName =
        customerStateRepsponse.data.application!.company!
            .registered_company_name;

    return (
        <TopUpStatusMessage
            heading={
                <FormattedMessage
                    id="_.outstanding_view.notTopupEligibleText"
                    defaultMessage="Sorry, you can't request more funds at the moment"
                />
            }
            description={
                <>
                    <strong>{companyName}</strong>{' '}
                    <FormattedMessage
                        id="_.outstanding_view.notTopupEligibleDescription"
                        defaultMessage="isn't eligible for additional funding - feel free to give your account manager a call if you'd like to know more."
                    />
                </>
            }
            ctaText={
                <FormattedMessage
                    id="_.outstanding_view.notTopupEligibleCTAText"
                    defaultMessage="Get in touch"
                />
            }
        />
    );
};
